import { useEffect } from 'react'

/**
 * Loads the Umami tracking script when it's configured, and does nothing
 * otherwise - so local dev and any build without the two env vars set stays
 * exactly as before. Umami is cookieless and doesn't collect personal data
 * by default, which is why it loads unconditionally rather than behind a
 * consent banner; see DEPLOYMENT.md for setup.
 */
function Analytics() {
  useEffect(() => {
    const src = import.meta.env.VITE_UMAMI_SCRIPT_URL
    const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID
    if (!src || !websiteId) return

    const script = document.createElement('script')
    script.defer = true
    script.src = src
    script.setAttribute('data-website-id', websiteId)
    document.head.appendChild(script)

    return () => {
      script.remove()
    }
  }, [])

  return null
}

export default Analytics
